'use client';
import { create } from 'zustand';

export type ErrorType = 'network' | 'server' | 'auth' | 'default';

interface ErrorModalState {
  isOpen: boolean;
  title: string;
  message: string;
  errorType: ErrorType;
  retryFn: (() => void) | null;
  fallbackMessage: string;

  showError: (opts: {
    title?: string;
    message: string;
    errorType?: ErrorType;
    retryFn?: () => void;
    fallbackMessage?: string;
  }) => void;
  close: () => void;
}

export const useErrorModal = create<ErrorModalState>((set) => ({
  isOpen: false,
  title: '',
  message: '',
  errorType: 'default',
  retryFn: null,
  fallbackMessage: '',

  showError: ({ title = 'Error', message, errorType = 'default', retryFn, fallbackMessage = '' }) => {
    set({ isOpen: true, title, message, errorType, retryFn: retryFn ?? null, fallbackMessage });
  },

  close: () => {
    set({ isOpen: false, title: '', message: '', errorType: 'default', retryFn: null, fallbackMessage: '' });
  },
}));

/**
 * Standalone helper — call outside React components (e.g. in api.ts interceptors)
 *
 * Usage:
 *   import { showGlobalError } from '@/store/useErrorModalStore';
 *   showGlobalError({ message: 'Network error', errorType: 'network', retryFn: () => fetchData() });
 */
export function showGlobalError(opts: Parameters<ErrorModalState['showError']>[0]) {
  useErrorModal.getState().showError(opts);
}
